import React, { useEffect, useRef } from "react";
import location from "../../assets/images/locationIcon.png";

export default function LocationIconTilt() {
  const imgRef = useRef(null);
  const maxRotation = 18;
  const perspective = 1000;

  useEffect(() => {
    const handleMouseMove = (e) => {
      const { clientWidth, clientHeight } = document.documentElement;
      let posX = e.pageX / clientWidth;
      let posY = e.pageY / clientHeight;
      posX = Math.min(Math.max(posX, 0), 1);
      posY = Math.min(Math.max(posY, 0), 1);
      const rotateY = Math.round(((posX * 2) - 1) * maxRotation);
      const rotateX = Math.round(((posY * -2) + 1) * maxRotation);
      if (imgRef.current) {
        imgRef.current.style.transform = `perspective(${perspective}px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      }
    };
    document.addEventListener("mousemove", handleMouseMove);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);
  return (
    <div className="relative">
      <div className="absolute w-[9.375rem] h-[9.75rem] bottom-[3.4375rem] -right-[8.1875rem] z-10">
        <img
          ref={imgRef}
          src={location}
          alt="Location Icon"
          className="mx-auto block w-full h-auto  transition-transform duration-75 will-change-transform"
        />
      </div>
    </div>
  );
}
